// import components
import ControlledValidFromValidTo from 'components/shared/ControlledFields/ControlledValidFromValidTo';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

// import external libraries
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { DateSectionProps } from '../types';

const DateSection = ({ control, setValue, toDate }: DateSectionProps) => {
  const { t } = useTranslation('common');

  useEffect(() => {
    if (!toDate) {
      setValue('valid.to', dayjs().year(2099).startOf('year').toDate());
    }
  }, []);

  return (
    <>
      <MultiStepForm.Section
        title={t('date')}
        validateFields={['valid.from', 'valid.to']}
      >
        <ControlledValidFromValidTo control={control} />
      </MultiStepForm.Section>
    </>
  );
};

export default DateSection;
